<template>
  <vi-page>
    <vi-card>
      <template v-slot:title>
        <div class="row">
          <div class="col-12">
            <div class="row align-items-center">
              <div class="icon-box">
                <vi-icon name="fas:shield-alt"></vi-icon>
              </div>
              <span class="ml-1 font-weight-bolder row">
                <span class="col-12">提交实名认证</span>
                <span class="col-12 font-size-sm text-muted"
                  >请上传您的实名认证信息</span
                >
              </span>
            </div>
          </div>
        </div>
      </template>
      <div class="form-group row align-items-center" v-if="rejectContentText">
        <div class="col-lg-4 col-form-label text-right">审核意见</div>
        <div class="col-lg-4 text-danger">{{ rejectContentText }}</div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          营业执照
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-6">
          <div>
            <vi-upload
              :files.sync="single"
              :action="action"
              type="image"
              accept=".png, .jpg, .jpeg"
            />
          </div>
          <div class="mt-4">上传营业执照图片；</div>
          <div class="text-black-50">
            <div class="mt-3">
              照片上所有信息需清晰可见，内容真实有效，不得做任何修改；
            </div>
            <div class="mt-3">
              照片支持：jpg、jpeg、bmp、gif、png、pdf格式，大小不超过8M。
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          社会统一信用代码/注册号/组织机构代码
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-4">
          <input
            type="text"
            class="form-control"
            placeholder="请输入证件上的统一信用代码或注册号或组织机构代码"
            v-model="args.number"
            maxlength="64"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          企业名称
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-4">
          <input
            type="text"
            class="form-control"
            v-model="args.name"
            placeholder="请填写营业执照上的企业名称"
            maxlength="128"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          经营期限
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-4 pl-0 ml-0">
          <vi-date-picker range v-model="range"></vi-date-picker>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          住所地址
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-4">
          <input
            type="text"
            class="form-control"
            v-model="args.address"
            placeholder="请填写营业执照上的住所地址"
            maxlength="256"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          法人代表身份证
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-6">
          <div class="row ml-0">
            <div>
              <vi-upload
                :files.sync="emblem"
                :action="action"
                type="image"
                accept=".png, .jpg, .jpeg"
              />
              <div class="mt-6">身份证国徽面</div>
            </div>
            <div class="ml-20">
              <vi-upload
                :files.sync="avatar"
                :action="action"
                type="image"
                accept=".png, .jpg, .jpeg"
              />
              <div class="mt-6">身份证头像面</div>
            </div>
          </div>
          <div class="mt-6 text-black-50">
            <div>照片上所有信息需清晰可见，内容真实有效，不得做任何修改；</div>
            <div class="mt-4">
              照片支持：jpg、jpeg、bmp、gif、png、pdf格式，大小不超过8M。
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          法人代表名称
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-4">
          <input
            type="text"
            class="form-control"
            v-model="args.legalname"
            placeholder="请填写法人代表身份证上的姓名"
            maxlength="32"
          />
        </div>
      </div>
      <div class="form-group row">
        <label class="col-lg-4 col-form-label text-right">
          身份证号码
          <span class="text-danger">*</span>
        </label>
        <div class="col-lg-4">
          <input
            type="text"
            class="form-control"
            v-model="args.code"
            placeholder="请填写法人代表身份证上的证件号码"
            maxlength="64"
          />
        </div>
      </div>
      <div class="btn_flex mt-20">
        <button type="button" class="btn btn-primary" @click="eSubmit()">
          提交
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          @click="eCancel()"
        >
          取消
        </button>
      </div>
    </vi-card>
  </vi-page>
</template>

<script>
var moment = require("moment");
export default {
  name: "PagesDashboardCustomerCertificationSubmit",
  data() {
    return {
      action: "/kernel/transaction/apis/biz/payment/order/offline/file/add",
      single: {},
      businessTime: "",
      emblem: {},
      avatar: {},
      range: [],
      args: {
        code: "",
        name: "",
        businessTime: "",
        address: "",
        legalname: "",
        number: "",
      },
      sn: "",
      rejectContentText: "",
    };
  },
  mounted() {
    this.oGetApplyCurrent();
  },
  methods: {
    eSubmit() {
      let args = {
        type: "Business",
        business: {
          name: this.args.name,
          number: this.args.number,
          imageUrl: this.single.url,
          address: this.args.address,
          businessStartTime: moment(this.range[0]).format("x"),
          businessEndTime: moment(this.range[1]).format("x"),
          legal: {
            name: this.args.legalname,
            frontImageUrl: this.emblem.url,
            backImageUrl: this.avatar.url,
            number: this.args.code,
          },
        },
      };
      if (this.sn) {
        args.sn = this.sn;
      }
      let result = this.eGetArags();
      if (result == false) {
        return;
      }

      this.$$.api
        .post("/shiyun/marketing/apis/biz/principal/apply/submit", args)
        .then(() => {
          this.$$.toastr.success("提交成功");
          this.eCancel();
        })
        .catch((error) => {
          this.$$.toastr.error(error.message);
        });
    },
    eCancel() {
      this.$$.navigate.navigateCurrentClose();
    },
    eGetArags() {
      var patrn = /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3})$/;
      if (!patrn.test(this.args.code)) {
        this.$$.toastr.error("请填写正确的身份证号码");
        return false;
      }
      if (!this.args.legalname) {
        this.$$.toastr.error("请填写法人代表名称");
        return false;
      }
      if (!this.args.code) {
        this.$$.toastr.error("请填写身份证号码");
        return false;
      }
      if (!this.emblem.url) {
        this.$$.toastr.error("请上传身份证国徽面");
        return false;
      }
      if (!this.avatar.url) {
        this.$$.toastr.error("请上传身份证头像面");
        return false;
      }
      if (!this.args.name) {
        this.$$.toastr.error("请填写企业名称");
        return false;
      }
      if (!this.args.number) {
        this.$$.toastr.error("请填写社会统一信用代码/注册号/组织机构代码");
        return false;
      }
      if (!this.single.url) {
        this.$$.toastr.error("请上传营业执照");
        return false;
      }
      if (!this.args.address) {
        this.$$.toastr.error("请填写住所地址");
        return false;
      }
      if (!this.range || this.range.length < 2) {
        this.$$.toastr.error("请选择经营期限");
        return false;
      }
      let date = moment().startOf("day");
      let expiredTime = moment(this.range[1]).toObject();
      let time = moment(expiredTime).diff(moment(date), "minutes");
      if (time <= 0) {
        this.$$.toastr.error("经营期限不允许小于或等于当前日期");
        return false;
      }
      return true;
    },
    oGetApplyCurrent() {
      this.$$.api
        .post("/shiyun/marketing/apis/biz/principal/apply/current")
        .then((res) => {
          let data = res.data;
          if (data.approveStatus === "Reject") {
            this.sn = data.sn;
            let content = data.content.business;
            let legal = data.content.business.legal;
            this.single = {
              url: content.imageUrl,
            };
            this.args.number = content.number;
            this.args.name = content.name;
            this.range = [content.businessStartTime, content.businessEndTime];
            this.args.address = content.address;
            this.emblem = { url: legal.frontImageUrl };
            this.avatar = { url: legal.backImageUrl };
            this.args.legalname = legal.name;
            this.args.code = legal.number;
            this.rejectContentText = data.rejectContent;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-box {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  background: #1bc5bd;
  align-items: center;
  border-radius: 50%;
  i {
    color: #fff;
    font-size: 25px;
  }
}
.btn_flex {
  display: flex;
  justify-content: space-evenly;
  button {
    width: 125px;
  }
}
.container {
  padding-left: 12.5px !important;
}
.apply_position {
  position: relative;
}
</style>